var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLifeBuoy = function SvgLifeBuoy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "life-buoy_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#life-buoy_svg__a)",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 4.5C12.895 4.5 4.5 12.895 4.5 23.25S12.895 42 23.25 42 42 33.605 42 23.25 33.605 4.5 23.25 4.5ZM2 23.25C2 11.514 11.514 2 23.25 2S44.5 11.514 44.5 23.25 34.986 44.5 23.25 44.5 2 34.986 2 23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.226 8.226a1.25 1.25 0 0 1 1.768 0l8.48 8.48a1.25 1.25 0 0 1-1.768 1.768l-8.48-8.48a1.25 1.25 0 0 1 0-1.768ZM38.274 8.226a1.25 1.25 0 0 1 0 1.768l-8.48 8.48a1.25 1.25 0 0 1-1.768-1.768l8.48-8.48a1.25 1.25 0 0 1 1.768 0ZM28.026 28.026a1.25 1.25 0 0 1 1.768 0l8.48 8.48a1.25 1.25 0 0 1-1.768 1.768l-8.48-8.48a1.25 1.25 0 0 1 0-1.768ZM18.474 28.026a1.25 1.25 0 0 1 0 1.768l-8.48 8.48a1.25 1.25 0 0 1-1.768-1.768l8.48-8.48a1.25 1.25 0 0 1 1.768 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 16.5a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM14 23.25a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 29c3.6-5.2 1.5-9.833 0-11.5l8.5-9c11.2 14.4 4.333 25.333-.5 29L29 29ZM17.554 29c-3.6-5.2-1.5-9.833 0-11.5l-8.5-9c-11.2 14.4-4.333 25.333.5 29l8-8.5Z"
  }))));
};
export default SvgLifeBuoy;